import type { Fact, FitView, RecordEntry } from "@/lib/posting";
import FactsCard from "./FactsCard";
import FitAtMatchCard from "./FitAtMatchCard";
import RecordCard from "./RecordCard";

/** The side column: the facts, the fit at the match once sent, and the record for a member. */
export default function PostingSide({
    facts,
    fitAtMatch,
    scoredAt,
    member,
    record,
    recordError,
}: {
    facts: Fact[];
    /** The fit at the match, shown once the application went and the posting names keywords. */
    fitAtMatch: FitView | null;
    scoredAt: string | undefined;
    member: boolean;
    record: RecordEntry[];
    recordError: Error | null;
}) {
    return (
        <div className="flex min-w-0 flex-[1_1_320px] flex-col gap-5">
            <FactsCard facts={facts} />
            {fitAtMatch && <FitAtMatchCard fit={fitAtMatch} scoredAt={scoredAt} />}
            {member && <RecordCard error={recordError} entries={record} />}
        </div>
    );
}
